 // Start of Selection
import React, { useState } from 'react';

function PinAuth({ correctPin, onAuthenticate }) {
  const [pin, setPin] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (pin === correctPin) {
      onAuthenticate();
    } else {
      alert('Incorrect PIN');
    }
  };

  return (
    <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100%' }}>
      <input
        type="password"
        value={pin}
        onChange={(e) => setPin(e.target.value)}
        placeholder="Enter PIN"
        style={{
          width: '50%',
          height: '50px',
          fontSize: '20px',
          textAlign: 'center',
          marginBottom: '10px',
          border: '1px solid #007BFF',
          borderRadius: '5px',
          padding: '10px',
          boxSizing: 'border-box',
        }}
      />
      <button type="submit"
        style={{
          width: '50%',
          height: '50px',
          fontSize: '20px',
          textAlign: 'center',
          marginBottom: '10px',
          backgroundColor: '#007BFF',
          color: 'white',
          border: 'none',
          borderRadius: '5px',
          cursor: 'pointer',
          transition: 'background-color 0.3s',
          boxSizing: 'border-box',
        }}
      >Submit</button>
    </form>
  );
}

export default PinAuth;